import { connect } from 'react-redux';
import BalancePage from './BalancePage';
import { createStructuredSelector } from 'reselect';
import { getBalance } from '../../redux/certificate/actions';
import { balance, loading } from '../../redux/certificate/selectors';
import { campaignData } from '../../redux/landing/selectors';

const actions = {
  getBalance,
};

const selectors = createStructuredSelector({
  balance,
  loading,
  campaignData,
});

export default connect(selectors, actions)(BalancePage);
